import React from "react";
import FaqSection from "./../components/FaqSection";

function FaqPage(props) {
  return (
    <FaqSection
      bgColor="default"
      size="medium"
      bgImage=""
      bgImageOpacity={1}
      title="Frequently Asked Questions"
      subtitle=""
    />
  );
}

export default FaqPage;
